import {Injectable} from '@angular/core';
import {DealPayrollTaskLine} from '../../../models/deal-payroll.model';
import {
  FORMULA_ID_PREFIX, FUNCTION_TYPE
} from './deal-payroll-detail.view.constants';

@Injectable()
export class DealPayrollDetailFormulaState {
  private activeTaskId: number = null;
  private trigger: HTMLElement;

  formulaId(task: DealPayrollTaskLine): string {
    return FORMULA_ID_PREFIX + task.taskId;
  }

  isOpen(task: DealPayrollTaskLine): boolean {
    return !!task && this.activeTaskId === task.taskId;
  }

  toggle(task: DealPayrollTaskLine, event: Event): void {
    event.stopPropagation();
    if (this.isOpen(task)) {
      this.close(true);
      return;
    }
    this.activeTaskId = task.taskId;
    this.trigger = event.currentTarget as HTMLElement;
  }

  closeIfOpen(): boolean {
    if (this.activeTaskId === null) {
      return false;
    }
    this.close(true);
    return true;
  }

  closeWithoutFocus(): void {
    this.close(false);
  }

  private close(restoreFocus: boolean): void {
    const trigger = this.trigger;
    if (restoreFocus && this.canFocus(trigger)) {
      trigger.focus();
    }
    this.activeTaskId = null;
    this.trigger = undefined;
  }

  private canFocus(trigger: HTMLElement): boolean {
    return !!trigger && typeof trigger.focus === FUNCTION_TYPE;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/my-working-report/deal-payroll-detail/deal-payroll-detail.formula-state.ts